import * as angular from 'angular';
import * as moment from 'moment';

import { ComponentDefinition, Dictionary, Group, IStringDateRange2, OnlineLog, OnlineLogViewModel, Pattern, RefreshClickData } from '../../../models';
import { IDateNavigationService, IOnlineComputationService, IStoreService } from '../../../services';
import { Store, StoreElement } from '../../../stateManagement';
import { refreshClick } from '../../../common/events';

class OnlineMessagesStateController implements angular.IComponentController {
    criteria: Pattern<OnlineLogViewModel>[];
    groups: Dictionary<Group>;
    initialRange: IStringDateRange2;
    isLoading: boolean;
    loadingMessage: string;
    viewModels: OnlineLogViewModel[];

    static $inject = [
        '$scope',
        'dateNavigationService',
        'onlineComputationService',
        'storeService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _dateNavigationService: IDateNavigationService,
        private _onlineComputationService: IOnlineComputationService,
        private _storeService: IStoreService
    ) {
    }

    $onInit() {
        this.criteria = this.initCriteria();
        const range = this._dateNavigationService.getLastNPeriod(0);
        this.initialRange = {
            beginDate: moment(range.beginDate).toISOString(),
            endDate: moment(range.endDate).toISOString()
        };
        this.isLoading = true;
        this._storeService.register(
            store => this.initStore(store),
            [StoreElement.Groups]
        );
    }

    private initCriteria(): Pattern<OnlineLogViewModel>[] {
        return [
            {
                label: 'Severity',
                model: 's',
                property: 's',
                isMatch: (log, regexp, value) => {
                    return log.status >= parseInt(value);
                },
                placeholder: '0: OK, 1: Warning, 2: Error'
            },
            {
                label: 'Group',
                model: 'g',
                property: 'g',
                isMatch: (log, regexp, value) => {
                    return regexp.test(log.group?.uniqueName);
                },
                placeholder: 'Unique name of the group'
            },
            {
                label: 'Step',
                model: 'st',
                property: 'st',
                isMatch: (log, regexp, value) => {
                    return regexp.test(log.stepName);
                },
                placeholder: 'Step name'
            },
            {
                label: 'Message',
                model: 'm',
                property: 'm',
                isMatch: (log, regexp, value) => {
                    return regexp.test(log.message);
                },
                placeholder: 'Message'
            }
        ];
    }

    private initStore(store: Store): void {
        this.groups = store.groups.dictionary;
        this.refresh(this.initialRange.beginDate, this.initialRange.endDate)
            .finally(() => {
                this._$scope.$on(refreshClick, (event, data: RefreshClickData) => {
                    this.refresh(data.beginDate, data.endDate, data.force);
                });
                this.isLoading = false;
            });
    }

    refresh(beginDate: string, endDate: string, force?: boolean): angular.IPromise<OnlineLogViewModel[]> {
        this.isLoading = true;
        const beginDateTime = moment(beginDate).utc().toISOString();
        const endDateTime = moment(endDate).utc().toISOString();
        return this._onlineComputationService
            .getOnlineErrors(beginDateTime, endDateTime, force)
            .then(data => {
                this.viewModels = data.map((d: OnlineLog) => Object.assign({}, d, { group: this.groups[d.guid] }));
                return this.viewModels;
            })
            .finally(() => this.isLoading = false);
    }
}

export const wtOnlineMessagesState: ComponentDefinition = {
    componentId: 'wtOnlineMessagesState',
    controller: OnlineMessagesStateController,
    template: require('./onlineMessagesState.component.html'),
    controllerAs: 'vm',
    bindings: {
    }
};